import { IAuthenticationService } from "services/AuthenticationService";
import { IAuthUsersService } from "services/AuthUsersService";
import { container } from "setup/dependency/inversify.config";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

// Server should return AuthModel
export function login(email: string, password: string) {
  const authenticationService = container.get<IAuthenticationService>(SERVICE_TYPES.AuthenticationService);
  return authenticationService.logIn(email, password);
}

// Server should return object => { result: boolean } (Is Email in DB)
export async function requestPassword(email: string) {
  const usersService = container.get<IAuthUsersService>(SERVICE_TYPES.AuthUsersService);
  return await usersService.passwordReset(email);
}

export async function getUserByToken(token: string) {
  const usersService = container.get<IAuthUsersService>(SERVICE_TYPES.AuthUsersService);
  const userModel = await usersService.getUserByToken(token);
  return userModel;
}

export async function logout() {
  const authenticationSerice = container.get<IAuthenticationService>(SERVICE_TYPES.AuthenticationService);
  await authenticationSerice.logOut();
}
